import { render, staticRenderFns } from "./decimal-input.vue?vue&type=template&id=01d4afd5&scoped=true"
import script from "./decimal-input.vue?vue&type=script&lang=js"
export * from "./decimal-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4afd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d4afd5')) {
      api.createRecord('01d4afd5', component.options)
    } else {
      api.reload('01d4afd5', component.options)
    }
    module.hot.accept("./decimal-input.vue?vue&type=template&id=01d4afd5&scoped=true", function () {
      api.rerender('01d4afd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/number-input/decimal-input.vue"
export default component.exports